<div class="mesa-escolhida-container" *ngIf="empresa && mesa">
  <div class="mesa-info-card">
    <div class="mesa-icon-container">
      <i class="fas fa-table"></i>
    </div>
    <div class="mesa-info">
      <small class="text-muted">{{empresa.identificadorMesa}}</small>
      <span class="font-weight-bold">{{mesa.nome}}</span>
    </div>
    <div *ngIf="codigoComanda" class="comanda-info">
      <i class="fas fa-receipt"></i>
      <span>{{codigoComanda}}</span>
    </div>
    <div *ngIf="garcom && garcom.id" class="garcom-info">
      <i class="fas fa-user"></i>
      <span>{{garcom.nome}}</span>
    </div>
  </div>
</div>
